(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ContactUsWithdraw"] = factory();
	else
		root["ContactUsWithdraw"] = root["ContactUsWithdraw"] || {}, root["ContactUsWithdraw"]["index"] = factory();
})(self, () => {
return 